export enum ModalResult {
  SUCCESS = 'Success'
}
